import { ModeForm } from "constants/enum";

import { Dispatch, SetStateAction } from "react";

import { Box } from "@mui/material";
import Button from "components/Button/Button";
import Save01Icon from "components/Icon/Save01";
import { UseFormReset } from "react-hook-form";

export interface Option {
  label: string;
  value: string;
}
interface Props {
  setIsModalCreateOpen: Dispatch<SetStateAction<boolean>>;
  reset: UseFormReset<any>;
  mode: ModeForm;
  handleSubmit?: any;
  setListFields?: Dispatch<SetStateAction<Option[]>>;
}
export const FooterFormModal = (props: Props) => {
  const { mode, reset, setIsModalCreateOpen, handleSubmit, setListFields } =
    props;
  return (
    <Box sx={{ float: "right", marginTop: "20px" }}>
      <Button
        variant="outlined"
        onClick={() => {
          setIsModalCreateOpen(false);
          reset();
          if (setListFields) {
            setListFields([]);
          }
        }}
      >
        Cancel
      </Button>
      <Button
        type="submit"
        sx={{
          display: `${mode === ModeForm.View ? "none" : ""}`,
          marginLeft: "8px",
        }}
        onClick={handleSubmit}
      >
        <Save01Icon sx={{ marginRight: "8px" }} />
        Save
      </Button>
    </Box>
  );
};
